<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div v-if="errors.key">
      <div v-for="error in errors.key" :key="error" class="text-red-600">{{ error }}</div>
    </div>
    <div v-if="!errors.key" class="text-center">
      <h2 class="text-2xl font-bold">Verifying your email...</h2>
    </div>
  </div>
</template>

<script>
import { makeAllauthRequestAndParseErrors } from '@/utils/auth';

export default {
  props: {
    'verificationKey': {
      type: String,
      required: true
    },
  },
  data() {
    return {
      errors: {}
    }
  },
  mounted() {
    this.verifyEmail()
  },
  methods: {
    async verifyEmail() {
      try {
        await makeAllauthRequestAndParseErrors({
          method: 'post',
          url: '_allauth/browser/v1/auth/email/verify',
          data: { key: this.verificationKey },
        })
        this.$router.push({name:'Login'})
      } catch (error) {
        if (error.fieldBasedErrors) {
          this.errors = error.fieldBasedErrors
        } else {
          throw error
        }
      }
    }
  }
}
</script>
